/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import ContentPaddings from '@/components/wrappers/general/ContentPaddings'
import { useResponsive } from '@/hooks/useResponsive'
import { Flex } from '@chakra-ui/react'

const MainFooter = ({
  logoUrl
}) => {
  const {
    flexGap,
    flexReverseDirection
  } = useResponsive()
  return (
    <ContentPaddings
      as="footer"
      py={6}
    >
      <Flex
        gap={flexGap}
        direction={flexReverseDirection}
        justify={{
          base: 'center',
          md: 'space-between'
        }}
      >
        <Flex
          alignItems="center"
          justify="center"
          textAlign="center"
          fontSize="14px"
        >
          Copyright © 2024 Personal Digital Spaces LLC | All Rights Reserved
        </Flex>
        <Flex
          alignItems="center"
          justify="center"
        >
          { logoUrl &&
            <img
              style={{ width: 'auto', height: '50px' }}
              display="inline-block"
              src={logoUrl}
            />
          }
        </Flex>
      </Flex>
    </ContentPaddings>
  )
}

export default MainFooter
